import CreateListResourceInteractor from "../../core/interactor/app/crud/CreateListResourceInteractor";
import Constants from "../common/Constants";
import { IOrganisationIndex } from "../model/OrganisationIndex";
import OrganisationIndexParamMapper from "../service/OrganisationIndexParamMapper";

export default class ConnectIndexesInteractor {
  private createListResource: CreateListResourceInteractor<IOrganisationIndex>;

  constructor({ createListResource }: any) {
    this.createListResource = createListResource;
  }

  async execute(
    organisationIndexId: number,
    organisationIndexes: IOrganisationIndex[],
    organisationId: number,
    label?: string
  ) {
    return this.createListResource.execute(
      `${Constants.organisationsPath}/${organisationId}/indexes/${organisationIndexId}`,
      organisationIndexes,
      {
        query: {
          label,
        },
      },
      OrganisationIndexParamMapper
    );
  }
}
